import type { ContentPage } from "@/lib/content/types";

// CRM › Salesforce Automation › Contact Management (leaf).
export const contactManagement: ContentPage = {
  slug: "salesforce-automation/contact-management",
  template: "hrmsFeature",
  seo: {
    title: "Contact Management Software - Organize Every Customer | GetBiz CRM",
    description:
      "Store, organize and access every customer contact with GetBiz CRM contact management software. A single, up-to-date view of every relationship and interaction.",
    keywords: [
      "contact management software",
      "customer contact database",
      "CRM contacts",
      "contact organization software",
      "customer database software",
      "contact management system",
    ],
    ogImage: "/assets/data/seoimages/contact-management.webp",
  },
  leaf: {
    hero: {
      caption: "Contact Management",
      title: "Every Customer Contact, Organized in One Place",
      description:
        "Keep a single, always-current record of every contact — with full interaction history, notes, and files — so your whole team has the context to build stronger relationships.",
      h1: "caption",
    },
    split: {
      title: "One Source of Truth for Every Relationship",
      bullets: [
        { title: "Unified Profiles", description: "Every email, call, note and deal on one contact record." },
        { title: "Smart Segmentation", description: "Group contacts by any field to target the right people." },
        { title: "Duplicate-free Data", description: "Automatic de-duplication keeps your database clean." },
        { title: "Instant Search", description: "Find any contact and their history in seconds." },
      ],
      image: "/assets/images/img/product/crm/relationshop-management.webp",
      imageAlt: "GetBiz CRM contact management software",
    },
    cardsHeading: {
      title: "Works With the Rest of Salesforce Automation",
      description:
        "Contact Management connects to every other part of your GetBiz CRM sales workflow.",
    },
    cards: [
      { title: "Lead Management", href: "/crm-software/salesforce-automation/lead-management/", description: "Turn captured leads into rich, connected contact records.", image: "/assets/images/img/product/crm/lead-managemnet-crm.webp", imageAlt: "CRM lead management" },
      { title: "Deal Management", href: "/crm-software/salesforce-automation/deal-management/", description: "Link contacts to the deals they influence across your pipeline.", image: "/assets/images/img/product/crm/deal-management-image-Photoroom.webp", imageAlt: "CRM deal management" },
      { title: "Account Management", href: "/crm-software/salesforce-automation/account-management/", description: "Group contacts under the companies and accounts they belong to.", image: "/assets/images/img/product/crm/account-management.webp", imageAlt: "CRM account management" },
      { title: "Cadences", href: "/crm-software/salesforce-automation/cadences/", description: "Enrol contacts into automated, multi-step outreach sequences.", image: "/assets/images/img/product/crm/cadence-image-Photoroom.webp", imageAlt: "CRM sales cadences" },
    ],
    testimonials: {
      title: "Stronger relationships with GetBiz CRM",
      description: "See why growing businesses trust GetBiz with their customer data.",
    },
    bookDemoTitle: "Give your team the full customer picture.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "contact-management-best-practices, customer-data-management-guide",
    metaKey: "contact-management",
  },
  sections: [],
};
